/* ============================================
   ET - Announcement bar with timer
   Counts down to a fixed date/time, or — when "Reset daily" is on —
   to the same time of day, rolling over to tomorrow once it passes.
   Time zone is either the shop's (offset rendered by Liquid) or the visitor's.
   ============================================ */
(function () {
  'use strict';

  var SEL = '[data-et-abt]';
  var DAY_MS = 86400000;

  /* "+0200" / "-0530" -> minutes east of UTC */
  function parseOffset(value) {
    var match = /^([+-])(\d{2}):?(\d{2})$/.exec((value || '').trim());
    if (!match) return 0;
    var minutes = parseInt(match[2], 10) * 60 + parseInt(match[3], 10);
    return match[1] === '-' ? -minutes : minutes;
  }

  function offsetMinutes(el) {
    if (el.dataset.tz === 'user') return -new Date().getTimezoneOffset();
    return parseOffset(el.dataset.shopOffset);
  }

  /* Epoch ms of the target moment, or NaN when the date is unusable. */
  function targetAt(el, now) {
    var offset = offsetMinutes(el) * 60000;
    var hour = parseInt(el.dataset.endHour, 10) || 0;
    var minute = parseInt(el.dataset.endMinute, 10) || 0;

    if (el.dataset.daily === 'true') {
      /* Shift the clock so getUTC* reads the wall time in the chosen zone. */
      var local = new Date(now + offset);
      var target =
        Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), hour, minute, 0) - offset;
      if (target <= now) target += DAY_MS;
      return target;
    }

    var year = parseInt(el.dataset.endYear, 10);
    var month = parseInt(el.dataset.endMonth, 10);
    var day = parseInt(el.dataset.endDay, 10);
    if (!year || !month || !day) return NaN;

    return Date.UTC(year, month - 1, day, hour, minute, 0) - offset;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function expire(el) {
    if (el.dataset.expiredBehavior === 'hide' && el.dataset.designMode !== 'true') {
      el.hidden = true;
      return;
    }
    el.classList.add('is-expired');
  }

  function initSection(el) {
    var parts = {
      days: el.querySelector('[data-et-abt-days]'),
      hours: el.querySelector('[data-et-abt-hours]'),
      minutes: el.querySelector('[data-et-abt-minutes]'),
      seconds: el.querySelector('[data-et-abt-seconds]')
    };

    if (el.etAbtTimer) clearInterval(el.etAbtTimer);

    function tick() {
      var now = Date.now();
      var target = targetAt(el, now);

      if (isNaN(target)) {
        clearInterval(el.etAbtTimer);
        expire(el);
        return;
      }

      var remaining = Math.max(0, target - now);

      if (remaining <= 0) {
        clearInterval(el.etAbtTimer);
        expire(el);
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);

      /* With the days unit hidden, roll the remaining days into hours. */
      if (!parts.days) hours += days * 24;

      if (parts.days) parts.days.textContent = pad(days);
      if (parts.hours) parts.hours.textContent = pad(hours);
      if (parts.minutes) parts.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      if (parts.seconds) parts.seconds.textContent = pad(totalSeconds % 60);

      el.classList.remove('is-expired');
    }

    tick();
    el.etAbtTimer = setInterval(tick, 1000);
  }

  function init(scope) {
    (scope || document).querySelectorAll(SEL).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll(SEL).forEach(function (el) {
      if (el.etAbtTimer) clearInterval(el.etAbtTimer);
    });
  });
})();
